import { render } from "./TemplateSlots.vue?vue&type=template&id=6f72fcba&scoped=true&ts=true"
import script from "./TemplateSlots.vue?vue&type=script&lang=ts"
export * from "./TemplateSlots.vue?vue&type=script&lang=ts"

import "./TemplateSlots.vue?vue&type=style&index=0&id=6f72fcba&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f72fcba"]])

export default __exports__